export default __webpack_public_path__ + "static/media/About.e33aa5a7.png";